import { LinearProgress, Stack } from "@mui/material";
import { isEmpty, take } from "lodash";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../auth/AuthContext";
import Actions from "../../components/actions/Actions";
import AddFab from "../../components/actions/AddFab";
import InfiniteScroll from "../../components/infiniteScroll/InfiniteScroll";
import { useLimit } from "../../misc/useLimit";
import { useOpenInNewTab } from "../../misc/useOpenInNewTab";
import { useAdminFiltersValue } from "../useAdminFilters";
import ProductCsvExport from "./csvExport/ProductCsvExport";
import ProductPricesImport from "./priceImport/ProductPricesImport";
import ProductCard from "./ProductCard";
import { useProducts } from "./useProducts";

const ProductsList = () => {
  const navigate = useNavigate();
  const { openChildInNewTab } = useOpenInNewTab();
  const { limit, loadMore } = useLimit();
  const { products, isLoading } = useProducts();
  const { query, providerId } = useAdminFiltersValue("products");
  const { context } = useAuthContext();
  const readOnly = context?.role === "AGENT" && !context?.customPrivileges.canEditProvidersProductsAndDictionaries;
  const canEditPriceLists =
    context?.role === "ADMIN" || (context?.role === "AGENT" && context?.customPrivileges.canEditPriceLists);

  const filteredProducts = products.filter(
    (p) =>
      (isEmpty(query) || p.name.toLowerCase().includes(query)) && (isEmpty(providerId) || p.provider.id === providerId),
  );

  return (
    <Stack
      sx={{
        height: "100%",
      }}
    >
      {isLoading && <LinearProgress />}
      <InfiniteScroll
        dataLength={limit < filteredProducts.length ? limit : filteredProducts.length}
        hasMore={limit < filteredProducts.length}
        fetchData={loadMore}
      >
        {take(filteredProducts, limit).map((p) => (
          <ProductCard
            key={p.id}
            value={p}
            onClick={() => navigate(readOnly ? p.id : `${p.id}/edit-single`)}
            onContextMenu={() => openChildInNewTab(p.id)}
          />
        ))}
      </InfiniteScroll>
      <Actions alignToBottom>
        {canEditPriceLists && <ProductPricesImport />}
        {!readOnly && (
          <>
            <ProductCsvExport />
            <AddFab label="dodaj produkt" onClick={() => navigate("new")} />
          </>
        )}
      </Actions>
    </Stack>
  );
};

export default ProductsList;
